import styled from "styled-components";

export const Wrapper = styled.footer`
  position: relative;
  background: ${({ theme }) => theme.customTheme.palette.footer.bgColor};
  box-sizing: border-box;

  /* mobile */
  padding: 72px 24px 72px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    /* tablet */
    padding: 72px 36px 72px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    /* desktop */
    padding: 96px 156px 96px;
  }
`;

/** Main inner container */
export const FooterContent = styled.div`
  max-width: 1384px;
  width: 100%;
  margin: 0 auto;
`;

/** Top area: logo + nav */
export const TopRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 32px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

/** Each link (always vertical list as in design) */
export const FooterItem = styled.li`
  font-family: ThemeFontRegular;
  padding: 4px 0;
  color: ${({ theme }) => theme.customTheme.palette.footerItem.textColor};

  a {
    font-weight: 400;
    font-size: ${({ theme }) => theme.customTheme.pxToRem(17)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(23.8)};
    font-size: var(--B2-Body---Regular-font-size, 17px);
    font-style: normal;
    letter-spacing: 0.352px;
    color: ${({ theme }) => theme.customTheme.palette.footerItem.textColor};
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    a {
      font-size: ${({ theme }) => theme.customTheme.pxToRem(18)};
      font-style: normal;
      line-height: ${({ theme }) => theme.customTheme.pxToRem(25.2)};
      letter-spacing: 0.389px;
      color: ${({ theme }) => theme.customTheme.palette.footerItem.textColor};
    }
  }
`;

/** Bottom area: divider + copyright on the right */
export const BottomRow = styled.div`
  border-top: 1px solid ${({ theme }) => theme.customTheme.palette.copyRight.textColor};
  padding-top: 12px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding-top: 16px;
  }
`;

export const CopyRightItem = styled.p`
  margin: 0;
  font-weight: 400;
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
  color: ${({ theme }) => theme.customTheme.palette.copyRight.textColor};
  text-align: right;
  line-height: ${({ theme }) => theme.customTheme.pxToRem(28)};

  ${({ theme }) => theme.customTheme.breakpoints.down("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(19)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(26.6)};
  }

  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(17)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(23.8)};
  }

  ${({ theme }) => theme.customTheme.breakpoints.down("xs")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(22.4)};
  }
`;

export const ScrollTopButton = styled.button`
  position: absolute;
  /* sit exactly on the top edge of the footer wrapper */
  top: 0;
  /* move the button up by half its height so it straddles the border */
  transform: translateY(-50%);

  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 999px;
  border: none;
  background: ${({ theme }) => theme.customTheme.palette.white.standard};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    right: 36px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    right: 60px;
  }

  font-size: 16px;
  line-height: 1;
  padding: 0;
  background-clip: padding-box;
`;

export const LogoImage = styled.img`
  display: block;
  height: 50px;
  width: auto;
  max-width: 100%;

  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    height: 39px;
  }
`;
